import React, { useState } from "react";
import { Tabs, TabsProps } from "antd";
import PageHeader from "../../component/pageHeaders";
import PhotosTab from "./components/PhotosTab";
import VideosTab from "./components/VideosTab";
import "./styles.css";
import GalleryTab from "./components/GalleryTab";
import AdvertisementTab from "./components/AdvertisementTab";
import BannerTab from "./components/BannerTab";
import InSnapsTab from "./components/InSnapsTab";

const SpecialPage = () => {
  const [activeTab, setActiveTab] = useState("1");

  const onChange = (key: string) => {
    setActiveTab(key);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Photos",
      children: <PhotosTab isActive={activeTab === "1"} />,
    },
    {
      key: "6",
      label: "In-Snaps",
      children: <InSnapsTab isActive={activeTab === "6"} />,
    },
    {
      key: "3",
      label: "Gallery Preview",
      children: <GalleryTab isActive={activeTab === "3"} />,
    },
    {
      key: "2",
      label: "Banners",
      children: <BannerTab isActive={activeTab === "2"} />,
    },

    {
      key: "4",
      label: "Advertisement",
      children: <AdvertisementTab isActive={activeTab === "4"} />,
    },
    {
      key: "5",
      label: "Videos",
      children: <VideosTab isActive={activeTab === "5"} />,
    },
  ];

  return (
    <div>
      <PageHeader title="Special Page Media" length="Special Page Media" />
      <br />
      <div className="special-page-container">
        <Tabs
          activeKey={activeTab}
          items={items}
          onChange={onChange}
          type="card"
          size="large"
        />
      </div>
    </div>
  );
};

export default SpecialPage;
